import { attr, hasMany } from 'spraypaint';

import ApplicationRecord from './ApplicationRecord';
import Feedback from './Feedback';

const Subscription = ApplicationRecord.extend({
  attrs: {
    cancelled_at: attr({ type: Date }),
    customer_id: attr({ type: Number }),
    default_delivery_option_id: attr({ type: Number }),
    delinquent_since: attr({ type: Date }),
    deliveries_updating_failed_at: attr({ type: Date }),
    deliveries_updating_since: attr({ type: Date }),
    delivery_frequency_weeks: attr({ type: Number }),
    delivery_weekdays: attr({ type: Array }),
    excluded_food_groups: attr({ type: Array }),
    feedbacks: hasMany({ type: Feedback }),
    meal_count_per_delivery: attr({ type: Number }),
    meal_plan: attr({ type: String }),
    portion_count_per_meal: attr({ type: Number }),
    shipped_legacy_deliveries_count: attr({ type: Number }),
    paused_until: attr({ type: Date }),
    unpaid_deliveries_count: attr({ type: Number }),
    unpaid_deliveries_since: attr({ type: Date }),
  },
  static: {
    endpoint: '/subscriptions',
    jsonapiType: 'subscriptions-subscriptions',
  },
  methods: {
    isCancelled() {
      return !!this.cancelled_at;
    },
    cancel() {
      if (this.cancelled_at) {
        throw new Error('Subscription is already cancelled');
      }

      this.cancelled_at = new Date().toISOString();

      return this.save().catch((error) => {
        this.cancelled_at = null;
        throw new Error(error);
      });
    },
  },
});

export default Subscription;
